export default {
    lang: {
        name: 'Group divisive'
    }
}